import axios from "axios";
import { ARHIVA_REST_URL } from "../../../environments/environment";

export const getPostsCall = (payload) => {
  return axios.post(`${ARHIVA_REST_URL}api/posts/list`, payload);
};
